<template>
  <div class="box box-widget">
    <div class="box-header with-border">
      <post-list-author :author="post.author" :created_at="post.created_at">
      </post-list-author>
      <post-list-item-button> </post-list-item-button>
    </div>
    <div class="box-body" style="display: block">
      <post-list-content :post="post"></post-list-content>
      <post-list-action :post="post"> </post-list-action>
      <post-list-activity :post="post"> </post-list-activity>
    </div>
    <post-list-comment :comments="post.comments"> </post-list-comment>
    <post-list-comment-input :author="post.author" :postId="post.id"> </post-list-comment-input>
  </div>
</template>
<script>
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
};
</script>